import { render, staticRenderFns } from "./kore-context.vue?vue&type=template&id=6dedea54&scoped=true&"
import script from "./kore-context.vue?vue&type=script&lang=js&"
export * from "./kore-context.vue?vue&type=script&lang=js&"
import style0 from "./kore-context.vue?vue&type=style&index=0&id=6dedea54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dedea54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
